import React, { useEffect, useState  } from "react";
import "../Pages/CleeQ.css";
import "../Pages/Responsive.css";
import { makeStyles } from "@material-ui/core/styles";
import Aos from "aos";
import "aos/dist/aos.css";
import ContactUs from "./ContactUs";
import {
  Facebook,
  Instagram,
  MailOutline,
  PhoneAndroidOutlined,
  Twitter,
  WhatsApp,
} from "@material-ui/icons";
// import Events from "../Events";
import "../Components/NavBar/NavBar.css";
import NavBar from "../Components/NavBar/NavBar";
import Exco2 from "../Components/Executives/Exco2";
import Exco1 from "../Components/Executives/Exco1";
import Exco8 from "../Components/Executives/Exco8";
import Exco6 from "../Components/Executives/Exco6";
import Exco7 from "../Components/Executives/Exco7";
import Exco5 from "../Components/Executives/Exco5";
import Exco4 from "../Components/Executives/Exco4";
import Exco3 from "../Components/Executives/Exco3";
import SocialHeadings from "../Components/SocialHeadings";

// const NavBar = () => {
//   return (
//     <div className="container NavBarContainer p-0">
//       <div>
//         <SoleraLogo />
//       </div>
//       <div>
//       <NavBarList/>
//       </div>

//       <div className="SignUpAndLoginContianer22">
//         <SignUpAndLogin />
//       </div>
//     </div>
//   );
// };

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

function Excos() {

  
  const [exco1Show, setExco1Show] = useState(false);
  const handleExco1 = () => setExco1Show(false);

  const [exco2Show, setExco2Show] = useState(false);
  const handleExco2 = () => setExco2Show(false);

  const [exco3Show, setExco3Show] = useState(false);
  const handleExco3 = () => setExco3Show(false);

  const [exco4Show, setExco4Show] = useState(false);
  const handleExco4 = () => setExco4Show(false);

  const [exco5Show, setExco5Show] = useState(false);
  const handleExco5 = () => setExco5Show(false);

  const [exco6Show, setExco6Show] = useState(false);
  const handleExco6 = () => setExco6Show(false);

  const [exco7Show, setExco7Show] = useState(false);
  const handleExco7 = () => setExco7Show(false);

  const [exco8Show, setExco8Show] = useState(false);
  const handleExco8 = () => setExco8Show(false);



  useEffect(() => {
    Aos.init({ duration: 1000 });
    window.scrollTo(0, 0); // This will scroll the page to the top when the component mounts
  }, []);

  const classes = useStyles();

  return (
    <div>
      <header className="SoleraSticky">
      <div className="SocialHeadings-Display">
          <SocialHeadings />
        </div>
        <NavBar />
      </header>

      {/* <div id="Home">
        <OurLanding />
      </div> */}

     
      {/* <div id="News">
        <News />
      </div>
      <div id="Projects">
        <Projects />
      </div> */}

      {/* <div id="Gallery">
        <Gallery />
      </div> */}

<div>
      <div className="SoleraBody1">
        <div className="container LandingContOthers landing-page-container">
          <div className="LandingCoverUp">
            <div className="LandingHedings1" data-aos="zoom-in-up">
              Alumni Executives
            </div>
            <p className="SoleraIntro1">Meet Our Excos</p>
          </div>
          <article>
            <div className="container VidionAndMissionCont33 p-0">
              <div className="row g-2">
                <div className="col">
                  <div className="container Excos p-0">
                    <div className="row g-2">
                      <div className="col-md-3">
                        <div className="ExcoCoantainer">
                          <div className="ExcoPix">
                            <div className="ExcoImg">
                              <img
                                src="/assets/solera/6001.png"
                                alt=""
                                className="ExcoPictures"
                              />
                            </div>
                          </div>
                          <center className="ExcoBioCont">
                            <div className="ExcoName">Afolabi Phillips</div>
                            <div className="ExcoPres">President</div>
                            <br />
                            <button
                              className="ReadMore-Btn"
                              onClick={() => setExco1Show(true)}
                            >
                              Read more about Afolabi ...
                            </button>
                          </center>
                        </div>
                      </div>
                      <div className="col-md-3">
                        {" "}
                        <div className="ExcoCoantainer">
                          <div className="ExcoPix">
                            <div className="ExcoImg">
                              <img
                                src="/assets/solera/6004.png"
                                alt=""
                                className="ExcoPictures "
                              />
                            </div>
                          </div>
                          <center className="ExcoBioCont">
                            <div className="ExcoName">Sam Onibanjo</div>
                            <div className="ExcoPres">Vice-president 1</div>
                            <br />
                            <button
                              className="ReadMore-Btn"
                              onClick={() => setExco2Show(true)}
                            >
                              Read more about Sam ...
                            </button>
                          </center>
                        </div>
                      </div>{" "}
                      <div className="col-md-3">
                        {" "}
                        <div className="ExcoCoantainer">
                          <div className="ExcoPix">
                            <div className="ExcoImg">
                              <img
                                src="/assets/solera/6003.png"
                                alt=""
                                className="ExcoPictures "
                              />
                            </div>
                          </div>
                          <center className="ExcoBioCont">
                            <div className="ExcoName">
                              Josephine Appah Shode
                            </div>
                            <div className="ExcoPres">Vice-president 2</div>
                            <br />
                            <button
                              className="ReadMore-Btn"
                              onClick={() => setExco3Show(true)}
                            >
                              Read more about Josephine ...
                            </button>
                          </center>
                        </div>
                      </div>
                      <div className="col-md-3">
                        {" "}
                        <div className="ExcoCoantainer">
                          <div className="ExcoPix">
                            <div className="ExcoImg">
                              <img
                                src="/assets/solera/6002.png"
                                alt=""
                                className="ExcoPictures "
                              />
                            </div>
                          </div>
                          <center className="ExcoBioCont">
                            <div className="ExcoName">Mayowa Oluyede</div>
                            <div className="ExcoPres">Walfare Officer</div>
                            <br />
                            <button
                              className="ReadMore-Btn"
                              onClick={() => setExco4Show(true)}
                            >
                              Read more about Mayowa ...
                            </button>
                          </center>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                  <div className="container Excos">
                    <div className="row g-2">
                      <div className="col-md-3">
                        {" "}
                        <div className="ExcoCoantainer">
                          <div className="ExcoPix">
                            <div className="ExcoImg">
                              <img
                                src="/assets/solera/6005.png"
                                alt=""
                                className="ExcoPictures "
                              />
                            </div>
                          </div>
                          <center className="ExcoBioCont">
                            <div className="ExcoName">Akintoye Akinosi</div>
                            <div className="ExcoPres">Social Secretary</div>
                            <br />
                            <button
                              className="ReadMore-Btn"
                              onClick={() => setExco5Show(true)}
                            >
                              Read more about Akintoye ...
                            </button>
                          </center>
                        </div>
                      </div>
                      <div className="col-md-3">
                        {" "}
                        <div className="ExcoCoantainer">
                          <div className="ExcoPix">
                            <div className="ExcoImg">
                              <img
                                src="/assets/solera/6006.png"
                                alt=""
                                className="ExcoPictures "
                              />
                            </div>
                          </div>
                          <center className="ExcoBioCont">
                            <div className="ExcoName">Olutayo Oyefeso </div>
                            <div className="ExcoPres">Financial Secretary</div>
                            <br />
                            <button
                              className="ReadMore-Btn"
                              onClick={() => setExco6Show(true)}
                            >
                              Read more about Olutayo ...
                            </button>
                          </center>
                        </div>
                      </div>{" "}
                      <div className="col-md-3">
                        <div className="ExcoCoantainer">
                          <div className="ExcoPix">
                            <div className="ExcoImg">
                              <img
                                src="/assets/solera/6007.png"
                                alt=""
                                className="ExcoPictures "
                              />
                            </div>
                          </div>
                          <center className="ExcoBioCont">
                            <div className="ExcoName">Emmanuel Chilaka</div>
                            <div className="ExcoPres">Treasurer</div>
                            <br />
                            <button
                              className="ReadMore-Btn"
                              onClick={() => setExco7Show(true)}
                            >
                              Read more about Emmanuel ...
                            </button>
                          </center>
                        </div>
                      </div>{" "}
                      <div className="col-md-3">
                        <div className="ExcoCoantainer">
                          <div className="ExcoPix">
                            <div className="ExcoImg">
                              <img
                                src="/assets/solera/6008.png"
                                alt=""
                                className="ExcoPictures "
                              />
                            </div>
                          </div>
                          <center className="ExcoBioCont">
                            <div className="ExcoName">Dr Oluwole Adeniyan</div>
                            <div className="ExcoPres">General Secretary</div>
                            <br />
                            <button
                              className="ReadMore-Btn"
                              onClick={() => setExco8Show(true)}
                            >
                              Read more about Oluwole ...
                            </button>
                          </center>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
      
      <div id="Photo Gallery">
        <ContactUs />
      </div>
      <Exco1
        show={exco1Show}
        onClose={handleExco1}
        onOpen={() => setExco1Show(true)}
      />
       <Exco2
        show={exco2Show}
        onClose={handleExco2}
        onOpen={() => setExco2Show(true)}
      />
       <Exco3
        show={exco3Show}
        onClose={handleExco3}
        onOpen={() => setExco3Show(true)}
      />
       <Exco4
        show={exco4Show}
        onClose={handleExco4}
        onOpen={() => setExco4Show(true)}
      />
       <Exco5
        show={exco5Show}
        onClose={handleExco5}
        onOpen={() => setExco5Show(true)}
      />
       <Exco6
        show={exco6Show}
        onClose={handleExco6}
        onOpen={() => setExco6Show(true)}
      />
       <Exco7
        show={exco7Show}
        onClose={handleExco7}
        onOpen={() => setExco7Show(true)}
      />
       <Exco8
        show={exco8Show}
        onClose={handleExco8}
        onOpen={() => setExco8Show(true)}
      />
    </div>

      








    </div>
  );
}

export default Excos;
